import React, { Component } from 'react';

import Page from '../../containers/Page';
import WelcomeContent from '../../components/WelcomeContent';

export default class HowToSOTU extends Component {
  render() {
    return (
      <Page pageTitle="How to SOTU">
        <div>
          <WelcomeContent howTo />
        </div>
      </Page>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/pages/HowToSOTU/index.jsx
 **/